module.exports = __webpack_public_path__ + "img/@ferra_agustina.28152def.png";